import React from "react";
import * as Icon from "react-feather";

import UtilityService from "../../../../services/UtilityService";

import WComponent from "../../../common/WComponent";

import ToolsNotice from "../kit/ToolsNotice";

class JournalIssues extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			priorReceivableEntry: props.statedPriorReceivable === undefined ? "" : String(props.statedPriorReceivable),
			receivableAsAtEntry: props.statedReceivableAsAt || ""
		};
	}

	onPriorReceivableApply = async () => {
		const { priorReceivableEntry } = this.state;
		const { onPriorReceivableStated } = this.props;
		const isBlank = String(priorReceivableEntry || "").trim() === "";

		if (isBlank) {
			UtilityService.alert({ type: "error", text: "Enter the closing balance, or 0 if the period closed empty." });
			return;
		}

		await onPriorReceivableStated({ amount: Number(priorReceivableEntry) });
	};

	onReceivableAsAtApply = async () => {
		const { receivableAsAtEntry } = this.state;
		const { onReceivableAsAtStated } = this.props;
		const isBlank = String(receivableAsAtEntry || "").trim() === "";

		if (isBlank) {
			UtilityService.alert({ type: "error", text: "Enter the date the Accounts Receivable report was run as at." });
			return;
		}

		await onReceivableAsAtStated({ date: receivableAsAtEntry });
	};

	issueKeyOf = ({ issue }) => {
		const keyParts = [issue.code, issue.roleKey, issue.checkKey, issue.attribute, issue.janeValue];
		const key = keyParts.filter(part => part !== undefined && part !== null).join("|");
		return key;
	};

	renderIssueRemedy = ({ issue }) => {
		const { isSaving } = this.props;
		const { priorReceivableEntry, receivableAsAtEntry } = this.state;

		const isPriorReceivable = issue.code === "priorReceivableUnknown" || issue.code === "receivableNeverReversed";
		const isReceivableDate = issue.code === "receivableDateUnstated" || issue.code === "receivableDateNotPeriodEnd";

		if (isReceivableDate) {
			return (
				<div className="journal-panel__issue-remedy">
					<div>{issue.remedy}</div>
					<div className="tk-action-row">
						<input
							className="tk-input journal-panel__issue-input"
							type="date"
							aria-label="Date the Accounts Receivable report was run as at"
							value={receivableAsAtEntry}
							onChange={({ target }) => this.update({ receivableAsAtEntry: target.value })}
						/>
						<button className="tk-button tk-button--secondary tk-button--compact" onClick={this.onReceivableAsAtApply} type="button" disabled={isSaving}>
							Use this date
						</button>
					</div>
				</div>
			);
		}

		if (!isPriorReceivable) {
			return <div className="journal-panel__issue-remedy">{issue.remedy}</div>;
		}

		return (
			<div className="journal-panel__issue-remedy">
				<div>{issue.remedy}</div>
				<div className="tk-action-row">
					<input
						className="tk-input journal-panel__issue-input"
						type="number"
						step="0.01"
						placeholder="0.00"
						aria-label="Receivable balance the previous period closed at"
						value={priorReceivableEntry}
						onChange={({ target }) => this.update({ priorReceivableEntry: target.value })}
					/>
					<button className="tk-button tk-button--secondary tk-button--compact" onClick={this.onPriorReceivableApply} type="button" disabled={isSaving}>
						Use this balance
					</button>
				</div>
			</div>
		);
	};

	render() {
		const { issues } = this.props;

		if (!issues || issues.length === 0) {
			return null;
		}

		return (
			<ToolsNotice tone="warning" icon={<Icon.AlertTriangle size={16} />} title="This journal cannot be posted yet" className="journal-panel__notice">
				<div className="journal-panel__issues">
					{issues.map(issue => (
						<div className="journal-panel__issue" key={this.issueKeyOf({ issue })}>
							<div className="journal-panel__issue-message">{issue.message}</div>
							{this.renderIssueRemedy({ issue })}
						</div>
					))}
				</div>
			</ToolsNotice>
		);
	}
}

export default JournalIssues;
